import Vue from 'vue';
import axios from 'axios'
import { storage, cookie } from '~/common/utils/storage';
import { Message } from 'element-ui'

// 基本配置
axios.defaults.timeout = 30000;
axios.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8'
axios.defaults.headers.patch['Content-Type'] = 'application/json; charset=utf-8'
axios.defaults.headers.put['Content-Type'] = 'application/json; charset=utf-8'

// 请求回调
axios.interceptors.request.use((config) => {
  // 设置sessionToken
  let sessionToken = '',lang = '',reg2 = /[\u4e00-\u9fa5]/;
  const listName = config.data?.listName || config?.params?.fromName;
  config.url = config.url.startsWith("/") ? config.url : "/" + config.url;
  sessionToken = storage.get('session_token') || storage.get('session_token', true);
  lang = storage.get('lang');
  //有可能自带X-Session-Token
  config.headers['X-Session-Token'] = config.headers['X-Session-Token'] ? config.headers['X-Session-Token'] : sessionToken || '';
  if(reg2.test(lang)) {
    storage.rm('lang');
    lang = 'zh-CN';
  }
  //有可能自带lang
  config.headers['Lang'] = lang || '';
  if(config.headers['has_no_token']) {
    //强制删除token
    delete config.headers['X-Session-Token']
  }
  if (listName === '后台订单项') {
    config.headers['X-Commerce-Token'] = "5t1w0arPizVD0BhIo743F1vC7XMKnd8A" //后台调用订单域接口
  } else if(listName === '后台-物流') {
    config.headers['X-Commerce-Token'] = "7sk9UIwUWMlqcbnRo6NMOaZ5GICZERsg" // 物流调用订单域接口
  }
  //内容域的接口加上商户id,其它域暂时不用
  if (config.url.includes('/cms')) {
    try {
      config.headers['shop-id'] = storage.get('profile').latest_shop_id || '';
    } catch (error) { }
  }
  return config
});

// 返回回调
let flag = true;
axios.interceptors.response.use((res) => {

  let _showNotify = true;
  if ('showNotify' in res.config.headers) _showNotify = res.config.headers['showNotify']
  if (res.headers['content-type']==='application/octet-stream'||(res.data.type && res.data.type === "application/octet-stream")) {
    return res;
  } else if (res.data && res.data.code == 401) {
    if (flag) {
      flag = false;
      storage.rm('session_token');
      storage.rm('session_token', true);
      cookie.rm('auth');
      let routeArr = process.env.PROJECT_NAME === 'content' ? ['/content/view/questionnaire', '/content/view/invitation'] : ['/srvContent/view'];
      flag = routeArr.some(item => {
        return window.location.pathname.includes(item);
      });
      if (flag) {
        window.location.reload();
      } else {
        const ua = process.client ? navigator.userAgent.toLowerCase() : ''
        if(ua.includes('mobile')) {// H5跳转登录页
          window.location.href = window.location.origin + '/mobile/login'
        } else {
          window.location.href= window.location.origin
        }
      }
      setTimeout(function () {
        flag = true;
      }, 3000);
      return res;
    }
  } else if (res.data && (res.data.code == 403 || res.data.code == 400)) {
    Message({
      message: res.data.msg,
      type: 'error',
    });
    return res;
  }
  else if (res.data && res.data.code == 500) {
    let tip = ''
    let content = ''
    if(/\\n/.test(res.data.msg)) {
      let arr = res.data.msg.split('\\n')
      arr.map(item => {
        if(item) {
          const tmp = `<p style="margin-bottom: 3px">${item}</p>`
          tip +=tmp
        }
      })
      content = tip
    } else {
      tip = res.data.msg
      content = `<div>${tip}</div>` 
    }
    Message({
      message: content ,
      duration: 3000,
      dangerouslyUseHTMLString: true,
      type: 'error'
    });
  }
  else if (res.data && res.data?.code !== 200) {
    if (_showNotify) {
      Message({
        message: res.data.msg,
        type: 'error'
      });
    }
    return res;
  }
  return res
});

// // 错误回调
// axios.onError(error => {
//   // 错误返回登录
//   if (error.response && error.response.status) {
//     switch (error.response.status) {
//       case 401:
//         if (process.client) {
//           storage.rm('session_token');
//           storage.rm('session_token', true);
//           storage.rm('profile');
//           cookie.rm('auth');
//           cookie.rm('columnDetail');
//           app.app.router.push('/');
//         }
//         break;
//       case 500:
//         Message({
//           message: '后台服务器超时！',
//           type: 'error'
//         });
//         break;
//     }
//   }
//   return false;
// });
axios.$get = async (url, params, headers) => {
  const res = await axios.get(url, {
    params: params,
    headers:headers
  })
  return Promise.resolve(res.data)

}
axios.$post = async (url, params,headers) => {
  const res = await axios.post(url, params, headers )
  return Promise.resolve(res.data)

}
axios.$patch = async (url, params) => {
  const res = await axios.patch(url,params)
  return Promise.resolve(res.data)

}
axios.$put = async (url, params, headers) => {
  const res = await axios.put(url, params, headers)
  return Promise.resolve(res.data)

}
axios.$delete = async (url, params) => {
  let p
  if (params?.data) {
    p = { data: params.data }
  } else if (params?.params) {
    p = { params: params.params }
  } else {
    p = { params: params }
  }
  const res = await axios({
    method: 'delete',
    url: url,
    ...p
  })
  return Promise.resolve(res.data)
}
const fn = async (params) => {
  const res = await axios({...params})
  if (res.config.responseType==='blob'||res.headers['content-type']==='application/octet-stream'||(res.data.type && res.data.type === "application/octet-stream")) {
    return Promise.resolve(res)
  }
  return Promise.resolve(res.data)
}
for (let k in axios) {
  if (axios.hasOwnProperty(k) && !(k in fn)) {
    fn[k] = axios[k]
  }
}
Vue.prototype.$axios = fn
export default axios
